import { render } from "./RuledAllocation.vue?vue&type=template&id=3d025ed2"
import script from "./RuledAllocation.vue?vue&type=script&lang=js"
export * from "./RuledAllocation.vue?vue&type=script&lang=js"

import "./RuledAllocation.vue?vue&type=style&index=0&id=3d025ed2&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInnerLoading,QTr,QTd});
